export const isUnderwriter = role => ['Underwriter', 'UnderwriterPI', 'UnderwriterEnergy', 'BusinessOperations'].includes(role);

export const isClaimsHandler = role => ['ClaimsHandler', 'ClaimsHandlerPI'].includes(role);
